function markExternalLink(link) {
  if (link.dataset.externalMarked) return;
  if (!link.hasAttribute('href')) return;
  if (link.target) return;
  if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
  if (link.hostname === window.location.hostname) return;

  const rel = new Set((link.getAttribute('rel') || '').split(' ').filter(Boolean));
  rel.add('noopener');
  rel.add('noreferrer');

  link.target = '_blank';
  link.setAttribute('rel', [...rel].join(' '));
  if (!link.hasAttribute('aria-describedby')) {
    link.setAttribute('aria-describedby', 'a11y-new-window-message');
  }
  link.dataset.externalMarked = 'true';
}

function markExternalLinks(root) {
  root.querySelectorAll('a[href]').forEach(markExternalLink);
}

markExternalLinks(document);

let pendingScan = 0;

new MutationObserver((mutations) => {
  const hasAdditions = mutations.some((mutation) => mutation.addedNodes.length > 0);
  if (!hasAdditions || pendingScan) return;

  const schedule = window.requestIdleCallback ?? window.requestAnimationFrame;
  pendingScan = schedule(() => {
    pendingScan = 0;
    markExternalLinks(document);
  });
}).observe(document.body, { childList: true, subtree: true });
